import { createMuiTheme } from "@material-ui/core";
import { getColorRgbaFromHex } from "../Helpers/ColorHelper";

export enum color {
  primary = "#FF6022",
  background = "#F3F1F1",
  placeholder = "#EAE7E6",
  galleryBackground = "#000000",
  text = "#34180E",
  card = "#FFFFFF",
  primaryBackground = "#FF5C20",
  primaryBackground01 = "#FFF7F4",
  primaryBackground02 = "#FFEBE4",
  primaryBackground03 = "#FFCEBC",
  primaryBackground04 = "#FF4113",
  primaryColor = "#34180E",
  primaryColor01 = "#34180E",
  primaryColor02 = "#34180E",
  primaryColor03 = "#333333",
  primaryColor04 = "#FFFFFF",
  grayBackground00 = "#E5E5E5",
  grayBackground01 = "#B0A39E"
}

export enum px {
  none = "0",
  px = "1px",
  xxs = "2px",
  xs = "4px",
  s = "8px",
  m = "12px",
  l = "16px",
  xl = "20px",
  xxl = "32px",
  xxxl = "48px",
}

export function useMuiTheme(shadowRoot: ShadowRoot) {
  return createMuiTheme({
    typography: {
      fontFamily: "Montserrat",
    },
    palette: {
      primary: {
        main: color.primary,
      },
      secondary: {
        main: color.placeholder,
      },
      text: {
        primary: color.text,
      },
    },
    overrides: {
      MuiAvatar: {
        img: {
          objectFit: "fill"
        }
      },
      MuiButton: {
        root: {
          textTransform: "none",
        },
        containedSecondary: {
          color: color.text,
          backgroundColor: getColorRgbaFromHex(color.grayBackground00, 0.50),
          "&:hover": {
            backgroundColor: color.primaryBackground02,
            color: color.primaryBackground
          }
        }
      },
      MuiListItem: {
        button: {
          "&:hover": {
            backgroundColor: color.grayBackground00
          },
          "&.active": {
            backgroundColor: color.primaryBackground01
          }
        }
      }
    }
  });
}
